export default "__VITE_ASSET__5890e49c__"